import { FC } from "react"
import { BlankStateSection } from "src/components/shared/BlankStateSection"
import { CenteredSpinner } from "src/components/shared/CenteredSpinner"
import { IProductV1 } from "src/domain/entities"
import { ProductListView } from "."

interface Props {
	list: IProductV1[]
	isLoading: boolean
	onUpdate: (product: IProductV1) => void
	onDelete: (product: IProductV1) => void
	onAddClick: () => void
}

export const ProductListController: FC<Props> = ({
	isLoading,
	list,
	onDelete,
	onUpdate,
	onAddClick,
}) => {
	if (isLoading) return <CenteredSpinner />

	if (list.length === 0) {
		return <BlankStateSection message="No products found." onAddClick={onAddClick} />
	}

	return <ProductListView list={list} onUpdate={onUpdate} onDelete={onDelete} />
}
